import { PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NavigationStart, Router } from '@angular/router';

/**
 * Profundidad de una ruta segun sus segmentos. `/` es 0, `/login` es 1,
 * `/app/procesos` es 2. La query string y el fragmento no cuentan.
 */
function depthOf(url: string): number {
  const path = url.split(/[?#]/, 1)[0];
  return path.split('/').filter(Boolean).length;
}

/**
 * Escribe `data-nav="forward" | "back"` en <html> antes de cada navegacion.
 *
 * La View Transition nativa solo sabe que la raiz cambio; no sabe si el usuario
 * entra o vuelve. Sin esa distincion el login entraria desde abajo tanto al
 * abrirlo como al cerrarlo, y el movimiento contradiria la accion. Comparar la
 * profundidad de las URLs la recupera: bajar de nivel es entrar, subir es
 * volver, y quedarse al mismo nivel se trata como entrar.
 *
 * Se llama desde `provideAppInitializer`, no desde un componente: debe estar
 * escuchando antes de la primera navegacion.
 */
export function trackNavDirection(): void {
  const isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  if (!isBrowser) return;

  const router = inject(Router);

  router.events.subscribe((event) => {
    if (!(event instanceof NavigationStart)) return;

    const from = depthOf(router.url);
    const to = depthOf(event.url);
    document.documentElement.dataset['nav'] = to < from ? 'back' : 'forward';
  });
}
